// Shared JSON-LD building blocks. Pure data (no asset imports) so any page
// component can reuse them. Keeps areaServed, offers, price band, and speakable
// specs consistent across service, geo, blog, and about pages.

const COUNTIES = [
  "Lancaster County",
  "York County",
  "Chester County",
  "Berks County",
  "Dauphin County",
  "Cumberland County",
];

// #46 Structured service area: a GeoCircle centered on Lancaster plus the
// counties Graystone serves, expressed as administrative areas.
export const AREA_SERVED: Record<string, unknown>[] = [
  {
    "@type": "GeoCircle",
    geoMidpoint: {
      "@type": "GeoCoordinates",
      latitude: "40.0379",
      longitude: "-76.3055",
    },
    geoRadius: "48000",
  },
  ...COUNTIES.map((name) => ({
    "@type": "AdministrativeArea",
    name: `${name}, PA`,
  })),
];

// #43 A non-binding offer signaling a free, no-obligation estimate. We do not
// advertise financing, so this deliberately omits any financing terms.
export const FREE_ESTIMATE_OFFER = {
  "@type": "Offer",
  name: "Free on-site inspection and written estimate",
  price: "0",
  priceCurrency: "USD",
  availability: "https://schema.org/InStock",
  areaServed: "Lancaster County, PA",
};

// General price band indicator for the business (defensible, non-specific).
export const PRICE_RANGE = "$$";

// #45 Speakable specification for voice assistants. Targets the page heading
// and any element explicitly marked with data-speakable.
export const SPEAKABLE = {
  "@type": "SpeakableSpecification",
  cssSelector: ["h1", "[data-speakable]"],
};
